export interface AppStateModel {
  sidebarOpen: boolean;
  waitingToUpdate: boolean; // Indicates that the app is waiting for the user to update the app
}

export const defaultAppState: AppStateModel = {
  sidebarOpen: false,
  waitingToUpdate: false,
};
